import React, { Component } from 'react';
import { Bullseye, Grid, GridItem, PageSection, Spinner, Stack, StackItem, Title } from '@patternfly/react-core';

import { BeersheetUpload } from './BeersheetUpload';
import Drafted from './Drafted';
import UndraftedAll from './UndraftedAll';
import UndraftedPositions from './UndraftedPositions';
import { convertBeersheet } from '@app/utils/utils';

class DraftBoard extends Component<any, any> {
  constructor(props) {
    super(props);

    this.state = {
      players: [],
      filteredPlayers: [],
      isFileLoaded: false,
      isLoading: true,
      currentDraft: 0,
      query: '',
    };
  }

  componentDidMount() {
    this.initDraftaid();
  }

  initDraftaid() {
    this.setState({
      isLoading: false,
      query: '',
    });
  }

  searchPlayers(query) {
    const players = this.state.players.filter((player) => player.name.toUpperCase().includes(query.toUpperCase()));

    this.setState({
      filteredPlayers: players,
      query: query,
    });
  }

  draft(player) {
    const players = this.state.players.slice();
    const index = players.indexOf(player);
    if (~index) {
      players[index].drafted = this.state.currentDraft + 1;
    }

    this.setState({
      currentDraft: this.state.currentDraft + 1,
      players: players,
      filteredPlayers: players,
      query: '',
    });
  }

  undo(currentDraft) {
    if (currentDraft === 0) {
      return;
    }

    const players = this.state.players.slice();
    const index = players.findIndex((p) => p.drafted === currentDraft);
    if (~index) {
      players[index].drafted = null;
    }

    this.setState({
      currentDraft: this.state.currentDraft - 1,
      players: players,
    });
  }

  reset() {
    const players = this.state.players.slice();
    if (confirm("Are you sure you want to reset your progress?")) {
      players.map((player, i) => {
        return (player.drafted = null);
      });
  
      this.setState({
        currentDraft: 0,
        players: players,
      });
    }
  }

  retrieveData = (data) => {
    data = convertBeersheet(data);
    this.setState({
      fileLoaded: true,
      players: data.rankings,
      filteredPlayers: data.rankings,
    });
  };

  render() {
    if (!this.state.fileLoaded) {
      return (
        <PageSection>
          <BeersheetUpload getBeersheet={this.retrieveData} />
        </PageSection>
      );
    }

    if (this.state.isLoading) {
      return (
        <PageSection className="loading">
          <Bullseye>
            <Stack className="loading-stack">
              <StackItem>
                <Spinner size="xl"></Spinner>
              </StackItem>
              <StackItem>
                <Title size="xl" headingLevel="h1">
                  Preparing Draftaid..
                </Title>
              </StackItem>
            </Stack>
          </Bullseye>
        </PageSection>
      );
    }

    return (
      <PageSection>
        <Grid hasGutter>
          <GridItem sm={12} md={6}>
            <UndraftedPositions players={this.state.players} draft={(p) => this.draft(p)} />
          </GridItem>
          <GridItem sm={12} md={6}>
            <Stack className="master-tables-stack">
              <StackItem id="undrafted-stack-item">
                <UndraftedAll
                  players={this.state.filteredPlayers}
                  draft={(p) => this.draft(p)}
                  search={(e) => this.searchPlayers(e.target.value)}
                  format={this.state.format}
                  query={this.state.query}
                />
              </StackItem>
              <StackItem id="drafted-stack-item">
                <Drafted
                  currentDraft={this.state.currentDraft}
                  players={this.state.players}
                  undo={(c) => this.undo(c)}
                  reset={() => this.reset()}
                />
              </StackItem>
            </Stack>
          </GridItem>
        </Grid>
      </PageSection>
    );
  }
}

export default DraftBoard;
